import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from "scrollreveal";
import OwlCarousel from 'owl.carousel';
import Instagram from './app/instagram.js';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    this.Instagram = new Instagram();

    let href = window.location.pathname;
    if(href === '/'){
        this.Instagram.getInstaFeed(9);
    }

    $(function() {
        // スクロールリーバル
        window.sr = new ScrollReveal({duration: 600});
        function domEach(items, callback) {
            if (typeof items === "string") {
                var items = $(items);
            }

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                // callback = callback.bind(item)
                callback(i, item);
            }
        }
        sr.reveal(".c-main-visual__image", {scale: 1, duration: 2000,distance: '0',delay: 600}, 100);
        sr.reveal(".c-page-header-lg__image", {scale: 1, duration: 800,distance: '0',delay: 400}, 100);
        sr.reveal(".c-main-visual__button", {scale: 1, duration: 1200,distance: '-20px',delay: 1600}, 100);
        sr.reveal(".c-block-media__inner", {scale: 1, duration: 800,distance: '0',origin: 'top',delay: 800}, 100);
        sr.reveal(".c-opening .l-container", {scale: 1, duration: 400,distance: '0',delay: 400}, 100);
        sr.reveal(".c-opening__bg", {scale: 1, duration: 1000,distance: '0',delay: 1200,viewFactor:'0.1'}, 100);
        sr.reveal(".c-works-slider", {scale: 1, duration: 600,distance: '0',delay: 800}, 100);
        sr.reveal(".c-news__inner", {scale: 1, duration: 0,distance: '0',delay: 600,viewFactor:'0.5', opacity:1,afterReveal: function(el) {$('.c-news__inner').addClass('is-active')}}, 100);
        sr.reveal(".c-block-magazine__inner", {scale: 1, duration: 800,distance: '0',delay: 400,opacity:1,viewFactor:'0.5',afterReveal: function(el) {$('.c-block-magazine__border-right,.c-block-magazine__border-left').addClass('is-active')}}, 100);
        sr.reveal(".c-block-magazine__text", {scale: 1, duration: 600,distance: '0',delay: 600}, 100);
        sr.reveal(".c-block-store__inner", {scale: 1, duration: 0,distance: '0',delay: 600,viewFactor:'0.5', opacity:1,afterReveal: function(el) {$('.c-block-store__title').addClass('is-active')}}, 100);
        sr.reveal(".c-block-store__content", {scale: 1, duration: 1000,distance: '0',delay: 800}, 100);
        sr.reveal(".c-landing-product__block.is-block01", {afterReveal: function(el) {$('.c-landing-product__block.is-block01 .c-landing-product__title').addClass('is-active')}}, 100);
        sr.reveal(".c-landing-product__block.is-block02", {afterReveal: function(el) {$('.c-landing-product__block.is-block02 .c-landing-product__title').addClass('is-active')}}, 100);
        sr.reveal(".c-landing-product__block.is-block03", {afterReveal: function(el) {$('.c-landing-product__block.is-block03 .c-landing-product__title').addClass('is-active')}}, 100);

        var blocks01 = $(".c-card-product__inner,.c-card-post,.c-landing-product,.c-block-point__inner");
        domEach(blocks01, function (key, item) {
            sr.reveal(item, {scale: 1,delay: 600,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[1], {delay: 800, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[2], {delay: 1100, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[3], {delay: 1400, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[4], {delay: 1700, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[5], {delay: 2000, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[6], {delay: 2300, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[7], {delay: 2500, scale: 1,duration: 800,distance: '0'}, 100);
            sr.reveal(item.children[8], {delay: 2700, scale: 1,duration: 800,distance: '0'}, 100);
        });
        var blocks02 = $(".c-page-header-lg__text");
        domEach(blocks02, function (key, item) {
            sr.reveal(item, {scale: 1,delay: 1000,duration: 1200,distance: '0'}, 100);
            sr.reveal(item.children[1], {delay: 1250, scale: 1,duration: 1200,origin: 'left',distance: '10px'}, 100);
            sr.reveal(item.children[2], {delay: 1500, scale: 1,duration: 1200,origin: 'left',distance: '10px'}, 100);
            sr.reveal(item.children[3], {delay: 1750, scale: 1,duration: 1200,origin: 'left',distance: '10px'}, 100);
        });

        var owls = $('.owl-carousel');
        if (owls.length === 0) {
            return false
        }
        owls.imagesLoaded(function () {
            $('.c-block-media .owl-carousel').owlCarousel({
                items: 3,
                dots: true,
                loop: true,
                nav: true,
                autoplay: true,
                autoplaySpeed: 500,
                center: true,
                navText: ['<img src="/wp-content/themes/lulukushel-html/dist/assets/images/img-slider-prev.png" />','<img src="/wp-content/themes/lulukushel-html/dist/assets/images/img-slider-next.png" />'],
                responsive : {
                    0 : {
                        margin: 20,
                    },
                    750 : {
                        margin: 32,
                    },
                },
            });
        });

    });
  }
}

window.GApp = new App();
